import MainImageTitleItem from "./common/MainImageTitleItem"
import MainPeopleSection from "./common/MainPeopleSection"
import ImageSectionItem from "./common/ImageSectionItem"
import IconTextSection from "./common/IconTextSection"
import MainIconSection from "./common/MainIconSection"
import PaddingSection from "./common/PaddingSection"
import SeparatorLine from "./common/SeparatorLine"
import MainGrayList from "./common/MainGrayList"
import { Link } from "react-router-dom"
import { useEffect, useState } from "react"
import "./Main.css"

const Main = () => {

    const images = [
        "/images/cabecera-1v2.jpg",
        "/images/cabecera-2v2.jpg",
        "/images/cabecera-3v2.jpg",
    ]

    const imagesMobile = [
        "/images/cabecera-1m.jpg",
        "/images/cabecera-2m.jpg",
        "/images/cabecera-3m.jpg",
    ]

    const texts = [
        "La plataforma que acerca tus instituciones a la ciudadanía",
        "Transparencia real: los debates, accesibles a cualquiera, en cualquier momento",
        "Los debates de tu institución, al alcance de cualquier ciudadano",
    ]
    const [index, setIndex] = useState(0)

    useEffect(() => {
        document.title = 'Séneca'
        window.scrollTo(0, 0)
    }, [])


    useEffect(() => {
        const interval = setInterval(() => {
            const activeDots = document.querySelectorAll(".active")
            for (const el of activeDots)
                el.classList.remove("active")
            setIndex((prev) => (prev + 1) % images.length)
        }, 7000);
        return () => clearInterval(interval);
    }, [images.length]);


    const selectIndicator = (e) => {
        setIndex(Number(e.target.id))
    }


    return (
        <main className="h100 w100 flex col jcenter mtminus100">

            <MainImageTitleItem
                images={images}
                imagesMobile={imagesMobile}
                texts={texts}
                index={index}
                selectIndicator={selectIndicator}
            />

            <MainIconSection
                itemArray={[
                    {
                        icon: "bi bi-camera-reels main-feature-icon",
                        title: "Grabación y catalogación",
                        link: "/funcionalidades/grabacion-y-catalogacion"
                    },
                    {
                        icon: "bi bi-diagram-3-fill main-feature-icon",
                        title: "Publicación",
                        description: "Tu canal institucional",
                        link: "/funcionalidades/publicacion"
                    },
                    {
                        icon: "bi bi-keyboard main-feature-icon",
                        title: "Transcripción",
                        description: "Actas automáticas con IA",
                        link: "/funcionalidades/transcripcion"
                    },
                    {
                        icon: "bi bi-gear main-feature-icon",
                        title: "Administración",
                        description: "Gestión sencilla",
                        link: "/funcionalidades/administracion"
                    },
                    {
                        icon: "bi bi-box main-feature-icon",
                        title: "Servicios",
                        description: "Soluciones flexibles",
                        link: "/servicios"
                    }
                ]}
            />

            <IconTextSection
                imageURL="/images/middle-image-1.png"
                title="20 años al servicio de las instituciones"
                textArray={[
                    "<p class='middle-section-label'><strong>Séneca es la herramienta que conecta a las instituciones con su ciudadanía.</strong> Un canal directo, sin intermediarios, para que cada debate, acuerdo y decisión llegue a quien importa: las personas.</p>",
                    "<p class='middle-section-label'>Dos décadas junto a parlamentos, diputaciones y municipios nos han dado una perspectiva única: conocemos los retos reales de la administración y hemos construido Séneca para resolverlos.</p>"]}
            />

            <ImageSectionItem
                imagePosition="before"
                layout="row"
                imageURL="/images/seneca-screen.png"
                title="Los debates a un clic"
                textArray={[
                    "<p class='middle-section-label'>Séneca ofrece una experiencia completamente personalizada para el seguimiento de la actividad parlamentaria, disponible las 24 horas del día, los 365 días del año.</p>",
                    "<p class='middle-section-label'>Mediante la publicación ordenada del debate de cada iniciativa, el ciudadano podrá seguir las intervenciones tanto en directo como en diferido, elegir los temas de su interés, seguir a parlamentarios o grupos, e incluso buscar cualquier intervención al instante por palabras clave.</p>",
                ]}
                isAnimatedImage="true"
                modern="true"
            />
            <SeparatorLine />

            <MainGrayList
                title="Lo que Séneca hace por ti"
                itemArray={[
                    {
                        icon: "bi bi-share-fill main-section-icon",
                        text: "<p className='middle-section-label-2'>El ciudadano podrá <strong>compartir</strong> de manera sencilla puntos concretos de las intervenciones en redes sociales, comentarlas, apoyarlas o criticarlas.</p>"
                    },
                    {
                        icon: "bi bi-cloud-arrow-down main-section-icon",
                        text: "<p className='middle-section-label-2'>La prensa y los analistas podrán <strong>descargar</strong> contenidos completos, intervenciones o clips seleccionando el formato adecuado a cada medio.</p>"
                    },
                    {
                        icon: "bi bi-person-raised-hand main-section-icon",
                        text: "<p className='middle-section-label-2'>Los representantes podrán <strong>recibir, estudiar y responder</strong> las inquietudes de los ciudadanos que se interesen por sus posturas o las de su grupo.</p>"
                    }
                ]}
            />
            <PaddingSection />

            <MainPeopleSection
                title="¿Quién usa Séneca?"
                itemArray={[
                    {
                        imageURL: "/images/person1.png",
                        text: "<p className='person-card-text'>Como <strong>Concejal</strong>, Séneca me ayuda a transmitir mi posición a la ciudadanía y a recibir sus inquietudes de forma más directa.</p>"
                    },
                    {
                        imageURL: "/images/person2.png",
                        text: "<p className='person-card-text'>Desde el <strong>Gabinete de Prensa</strong> difundimos la información de las sesiones con vídeos, fotos y notas de prensa bien organizadas.</p>"
                    },
                    {
                        imageURL: "/images/person3.png",
                        text: "<p className='person-card-text'>Para nuestro <strong>Departamento de Publicaciones</strong>, Séneca es clave para organizar el trabajo y aprovechar la transcripción automática.</p>"
                    },
                    {
                        imageURL: "/images/person4.png",
                        text: "<p className='person-card-text'>Para los <strong>Medios de comunicación</strong>, Séneca es una herramienta autónoma y práctica para acceder a la información y localizar datos clave.</p>"
                    },
                    {
                        imageURL: "/images/person5.png",
                        text: "<p className='person-card-text'>Los <strong>ciudadanos</strong> por fin tienen sus instituciones a su alcance, cuando quieren y de forma más transparente.</p>"
                    }
                ]}
            />

            <section className="main-cta-section">
                <h2 className="main-cta-title">¿Quieres ver Séneca en acción?</h2>
                <p className="main-cta-desc">Cuéntanos tu caso y te mostramos cómo Séneca puede adaptarse a tu institución.</p>
                <Link to="/contacto" className="main-cta-button">Solicitar información</Link>
            </section>

        </main>
    )

}

export default Main
